import { ASChartHBar, ASChartHBarProps } from '@eleventheye/asui';
import { getTeamColorsByTeamId } from 'helpers/TeamHelpers';
import React from 'react';

type TeamHorizontalChartProps = {
  teamId: number;
} & ASChartHBarProps;

const TeamHorizontalChart: React.FC<TeamHorizontalChartProps> = ({ teamId, ...props }) => {
  const teamColors = getTeamColorsByTeamId(teamId);
  return <ASChartHBar {...props} primaryColor={teamColors.primary} secondaryColor={teamColors.secondary} withShadow />;
};

export default TeamHorizontalChart;
